import { type NotEarner } from '@/entities/wheel/model/wheel.types';

import { api } from '../api';

export const getTopNotEarners = () => {
  return api.get<NotEarner[]>('/v1/wheel/topnotearners').then((res) => res.data ?? []);
};
